import React from 'react';
import EntityProperties from '../../../shared/EntityProperties';
import {CustomerContactType} from '../../../../constants/EntityTypeNames';
import {getStyle} from '../../../../styles/styles'
var style = getStyle();

export default class ContactPropertiesForm extends React.Component {
    state = {
        contactID: 0,
        entityPropertiesSaveProcess: false,
    }

    onFinishEntityPropertiesSaveProcess(){
        this.props.getSaveProperties(false);
    }

    /*handleButtonSaveClick(){
        this.setState({entityPropertiesSaveProcess: true});
    }*/

    render(){
        var propertyId = 'contact-property-'+this.props.contactID;
        var section = (
            <form className="uk-form-stacked uk-grid">
                <div className="uk-width-1-1 uk-margin">
                    <EntityProperties id={propertyId} fullScreen={true} entityType={CustomerContactType} entityID={this.props.contactID} runSaveProcess={this.props.saveProperties} finishSaveProcess={this.onFinishEntityPropertiesSaveProcess.bind(this)} />
                </div>
                {/*<div>
                    <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleButtonSaveClick.bind(this)} type="button">Save</button>                        
                </div>*/}
            </form>
        )
        if(this.props.contactID === 0){
            section = (
                <div>
                    <h5 style={style.alignCenter}>Must create contact first.</h5>
                </div>
            )
        }
        return(
            <div>
                {section}
            </div>
        );
    }
}